import React from 'react'

export default ({ filterExpanded, toggleFilter, message }) =>
    !filterExpanded && (
        <div className="noDataComponentWrapper">
            <div className="noDataComponent">
                {message || (
                    <>
                        <span className="noDataText">
                            No results found. Please
                        </span>
                        <span
                            onClick={() => toggleFilter(true)}
                            className="noDataResetFilterText"
                        >
                            refine filter results
                        </span>
                    </>
                )}
            </div>
        </div>
    )
